import React from 'react';
import Mand_Classwise_Sub from './Mand_Classwise_Sub';
import '../../../CommonCSS/SocietyCSS.css'

const Mand_Classwise_SubApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Mandatory Classwise Subject</h5>
          </div>  
        </div>
        <Mand_Classwise_Sub/>
      </div>
    </div >
  );
};

export default Mand_Classwise_SubApp;
